import React from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';

import { url } from 'js/services/Network';
import { lightGrey1Color } from 'js/config/style';
import Chevron from 'js/components/core/Icons/Chevron';

const LeftChevron = styled(Chevron).attrs({ direction: 'left' })`
  margin-right: 0.5rem;
  top: -2px;
`;

const DashLink = styled(Link)`
  color: black;
  padding: 0 1rem;
  height: 2.5rem;
  display: block;
  float: left;

  &:hover {
    background: ${lightGrey1Color};
    color: black;
    text-decoration: none;
  }

  &:active {
    background: ${lightGrey1Color.darken(0.1)};
  }
`;

export default () => (
  <DashLink to={url('user-dashboard-page')}>
    <LeftChevron /> Dashboard
  </DashLink>
);
